import useFetch from 'utils/hooks/useFetch'
import { ApiDeleteEdc, ApiGetEdc, ApiGetEdcBankList, ApiGetEdcList, ApiInsertEdc, ApiUpdateEdc } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function EdcService() {
    const { showFail } = useModal()

    const { fetch: getEdcList } = useFetch(ApiGetEdcList)
    const { fetch: getEdcBankList } = useFetch(ApiGetEdcBankList)
    const { fetch: apiInsertEdc } = useFetch(ApiInsertEdc)
    const { fetch: apiUpdateEdc } = useFetch(ApiUpdateEdc)
    const { fetch: apiDeleteEdc } = useFetch(ApiDeleteEdc)
    const { fetch: apiGetEdc } = useFetch(ApiGetEdc)
 
    const fetchEdcList = async(bankId, edcName, beneficiaryAccountNo, beneficiaryName, status, pageSize, pageIndex) => {
        const res =  await getEdcList({
            data: {
                bankId,
                edcName, 
                beneficiaryAccountNo,
                beneficiaryName,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchEdcBankList = async () => {
        const res = await getEdcBankList({
            data: { }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchInsertEdc = async (bankId, edcName, beneficiaryAccountNo, mdrOn, mdrOff, mdrQrisOn, mdrQrisOff, mdrCreditAmex, mdrDebitOnUs, mdrDebitOffUs, beneficiaryId, type) => {
        const res = await apiInsertEdc({
            data:{
                bankId,
                edcName,
                beneficiaryAccountNo,
                mdrOn,
                mdrOff,
                mdrQrisOn,
                mdrQrisOff,
                mdrCreditAmex,
                mdrDebitOnUs, 
                mdrDebitOffUs,
                beneficiaryId,
                type
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchUpdateEdc = async (edcId, bankId , edcName, beneficiaryAccountNo, mdrOn, mdrOff, mdrQrisOn, mdrQrisOff, mdrCreditAmex, mdrDebitOnUs, mdrDebitOffUs, beneficiaryId, type) => {
        const res = await apiUpdateEdc({
            data:{
                edcId,
                bankId,
                edcName,
                beneficiaryAccountNo,
                mdrOn,
                mdrOff,
                mdrQrisOn,
                mdrQrisOff,
                mdrCreditAmex,
                mdrDebitOnUs,
                mdrDebitOffUs,
                beneficiaryId,
                type
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchDeleteEdc = async (edcId, status) => {
        const res = await apiDeleteEdc({
            data:{
                edcId,
                status
            }
        })
        
        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res           
    }
    const fetchEdcById = async (edcId) => {
        const res = await apiGetEdc({
            data: {
                edcId
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchEdcList,
        fetchEdcBankList,
        fetchInsertEdc,
        fetchUpdateEdc,
        fetchDeleteEdc,
        fetchEdcById
    }
}